import readXlsxFile from "read-excel-file"
import writeXlsxFile from "write-excel-file"
import BaseApi from "../../../../api/api"
import { NotificationService } from "../../../../features/NotificationService/NotificationService"
import { SAMSON_RECODE_SCHEMA } from "../helpers/constant"

export type RecodeSamsonYaType = {
  article: number
  offer_id: string
  count: number
  sizes: string
  weight: number
}

export const parseSamsonYaRecode = async (
  file: File,
): Promise<RecodeSamsonYaType[]> => {
  const dataFromXslx = await readXlsxFile<RecodeSamsonYaType>(file, {
    schema: SAMSON_RECODE_SCHEMA.YA.JSON,
  })
  return dataFromXslx.rows
}

export const downloadSamsonYaRecode = async () => {
  try {
    const { success, items } = await BaseApi.getRecodeYaSamson()
    if (success) {
      writeXlsxFile(items, {
        schema: SAMSON_RECODE_SCHEMA.YA.EXCEL,
        fileName: "перекодировка самсон яндекс.xlsx",
      })
    } else {
      NotificationService.showNotification({
        level: "error",
        message: "Произошла ошибка",
      })
    }
  } catch (e) {}
}
